module.exports = __webpack_public_path__ + "img/production.ec318146.svg";